import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
  Flex,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/core';
import bip21 from 'bip21';
import QRCode from 'qrcode.react';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import QRImage from '../../assets/qrcode.svg';
import CopyInputAddon from '../../components/CopyInputAddon';
import { useAsyncInterval } from '../../hooks/useAsyncInterval';
import { createClient, getClient } from '../../services/chainClient';
import { RootState } from '../../store/reducers';
import { getBTCValue, getUsedUtxos, toBTC } from '../../utils/Utils';

const ESTIMATED_SIZE = 312;

const BetDeposit = ({ onBack, onDeposit, betAmount }) => {
  const mnemonic = useSelector((state: RootState) => state.wallet.mnemonic);

  const [feePerByte, setFeePerByte] = useState(10);
  const [depositAddress, setDepositAddress] = useState('');
  const [readyToPoll, setReadyToPoll] = useState(false);
  const [usedUtxos, setUsedUtxos] = useState<any[]>([]);

  const alreadyDeposited = useRef(false);

  const { isOpen, onOpen, onClose } = useDisclosure();

  useAsyncInterval(async () => {
    if (!readyToPoll || alreadyDeposited.current) return;
    try {
      const outputs = [{ to: BurnAddress, value: (betAmount + ESTIMATED_SIZE * (feePerByte - 1)) }];
      const inputsForAmount = await getClient().getInputsForAmount(
        outputs,
        usedUtxos,
        1
      );

      alreadyDeposited.current = true;
      onDeposit({ ...inputsForAmount, feePerByte });

      console.log('inputsForAmount', inputsForAmount);
    } catch (e) {
      console.error(e);
    }
  }, 5000);

  useEffect(() => {
    if (!mnemonic) return;

    (async () => {
      const bitcoin = createClient(mnemonic);

      const _feePerByte = Math.max(
        2,
        Math.ceil(await bitcoin.getMethod('getFeePerByte')())
      );

      const address = await bitcoin.getMethod('getUnusedAddress')();

      setFeePerByte(_feePerByte);
      setUsedUtxos(await getUsedUtxos());
      setDepositAddress(address.address);

      setReadyToPoll(true);
    })();
  }, [mnemonic]);

  const amountToSend = betAmount + ESTIMATED_SIZE * feePerByte;
  const amountToSendBTC = toBTC(amountToSend);

  return (
    <>
      <Box>
        <Alert bg="#BF6358" p={1} mb={4}>
          <AlertIcon color="white" w={20} mr={0} />
          <AlertDescription color="white" fontSize="xs">
            <b>Caution:</b> Please make sure to send the exact amount specified
            below. It is slightly higher than the initial bet amount to account
            for on-chain fees to create the bet
          </AlertDescription>
        </Alert>

        <Box w="fit-content" mb={8}>
          <FormLabel fontSize="md">Send Exactly This Amount</FormLabel>
          <InputGroup>
            <Input
              isReadOnly
              w="200px"
              value={
                depositAddress ? `${amountToSendBTC} BTC` : 'Calculating...'
              }
            />

            <InputRightElement
              pr="4rem"
              w="fit-content"
              whiteSpace="nowrap"
              pointerEvents="none"
              children={
                <Text color="#a0a0a0">${getBTCValue(amountToSendBTC)} USD</Text>
              }
            />
            <CopyInputAddon copyValue={amountToSendBTC} />
          </InputGroup>
        </Box>

        <Box w="fit-content">
          <FormLabel fontSize="md">Deposit BTC Address</FormLabel>
          <Flex alignItems="center">
            <InputGroup w="fit-content">
              <Input w="300px" isReadOnly value={depositAddress} />
              <CopyInputAddon copyValue={depositAddress} />
            </InputGroup>

            <Text as="span" fontSize="sm" fontWeight="bold" mx={2}>
              OR
            </Text>

            <Button size="sm" colorScheme="blue" onClick={onOpen}>
              <Image p={1} color="white" src={QRImage} boxSize="25px" />
              Scan QR
            </Button>
          </Flex>
        </Box>
      </Box>
      <Flex flexDir="row" mt={8}>
        {/* <Button onClick={onBack}>Go Back</Button> */}
        <Button
          ml="auto"
          colorScheme="blue"
          isLoading
          loadingText="Waiting for deposit..."
        >
          C
        </Button>
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay>
          <ModalContent>
            <ModalCloseButton />
            <ModalBody textAlign="center">
              <Flex justifyContent="center">
                <QRCode
                  value={bip21.encode(depositAddress, {
                    amount: amountToSendBTC,
                    label: 'Bet deposit',
                  })}
                />
              </Flex>
              <Text mt={4}>{depositAddress}</Text>
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      </Modal>
    </>
  );
};

export default BetDeposit;

const BurnAddress = 'bcrt1qxcjufgh2jarkp2qkx68azh08w9v5gah8u6es8s';
